import BlockIcon from "@mui/icons-material/Block";
import DoneIcon from "@mui/icons-material/Done";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { PIPELINE_INSTANCE_STATUS } from "../../constants";
import PauseIcon from "@mui/icons-material/Pause";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import SyncIcon from "@mui/icons-material/Sync";

/**
 * Returns an object for icon style, depending on the inputed pipeline status.
 * @param {status} string - The status of the pipeline.
 * @returns {object} - An object containing an Icon (component, never null), a title (string), and a color (also string)
 */
export function getPipelineStatus(status = undefined) {
    switch (status) {
        case PIPELINE_INSTANCE_STATUS.PLANNED:
            return {
                Icon: HourglassTopIcon,
                title: "Planned",
                color: "grey",
            };
        case PIPELINE_INSTANCE_STATUS.ONGOING:
            return {
                Icon: SyncIcon,
                title: "Processing",
                color: "grey",
            };
        case PIPELINE_INSTANCE_STATUS.ERROR:
            return {
                Icon: ReportProblemIcon,
                title: "Error",
                color: "error",
            };
        case PIPELINE_INSTANCE_STATUS.FINISHED:
            return {
                Icon: DoneIcon,
                title: "Finished",
                color: "success",
            };
        case PIPELINE_INSTANCE_STATUS.SUSPENDED:
            return {
                Icon: PauseIcon,
                title: "Suspended",
                color: "warning",
            };
        case PIPELINE_INSTANCE_STATUS.ABORTED:
            return {
                Icon: BlockIcon,
                title: "Aborted",
                color: "error",
            };
        default:
            return {
                Icon: QuestionMarkIcon,
                title: "Unknown",
                color: "grey",
            };
    }
}
